import { Command } from 'cmdk';
import styled from 'styled-components';
import { Badge } from 'ui/badge';
import { body2, caption, colors, duration, easing, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ItemRow = styled(Command.Item)`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  content-visibility: auto;
  cursor: pointer;
  user-select: none;
  border-radius: ${spacing.quarter};
  transition: all ${duration.short} ${easing.exit};

  &[data-selected='true'] {
    background: ${colors.backgroundPrimaryHover};
  }

  /* we aren't currently using disabled */
  &[data-disabled='true'] {
    color: ${colors.textDisabled};
    cursor: not-allowed;
  }

  &:hover {
    transition: all ${duration.short} ${easing.entrance};
    background: ${colors.backgroundPrimaryHover};
  }

  &:active {
    transition: all ${duration.short} ${easing.entrance};
    background: ${colors.backgroundPrimaryHover};
  }
`;

export const ItemColumn = styled.div`
  padding: ${spacing.half};
`;

export const SuffixWrapper = styled(ItemColumn)`
  display: flex;
  gap: ${spacing.base};
  align-items: center;
`;

/** Wrap images for consistent view */
export const StyledThumbnailWrapper = styled.div`
  width: ${pxToRem(60)};
  height: ${pxToRem(50)};
`;

/** Status badge for campaigns and journeys */
export const StyledBadge = styled(Badge)`
  min-width: ${spacing.x5};
`;

export const ShortcutWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  padding: ${spacing.half};
  visibility: hidden;

  // visually hide by default and display when focused (tab or hover)
  [cmdk-item][aria-selected='true'] & {
    visibility: visible;
  }
`;

export const Shortcut = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  color: ${colors.iconSubtle};

  > span {
    color: ${colors.textSecondary};
  }
`;

export const Medium = styled.div`
  ${caption}
  display: flex;
  justify-content: center;
  gap: ${spacing.half};
  min-width: ${spacing.x4};
  color: ${colors.textSecondary};
`;

// Added below

/** Wrapper for icon/image, name and id */
export const ResourceInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  /* force row to be full width */
  flex-grow: 1;
  /* allow text to overflow */
  min-width: 0;
  padding: ${spacing.half};
  color: ${colors.textSecondary};

  /* force icon to always be 24px */
  > svg {
    flex: none;
  }
`;

/** Resource name */
export const Name = styled.span`
  ${body2}
  max-width: 100%;
  flex: 0 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/** Optional resource id displayed and searchable */
export const ID = styled.span`
  ${caption}
  flex: none;
  align-items: center;
  color: ${colors.textSecondary};
  line-height: ${spacing.plusQuarter};
  font-feature-settings: 'tnum';
  min-width: ${spacing.x5};
`;
